/** Общий фон панели мобильного меню и хедера, пока меню открыто */
export const siteHeaderMobileNavSurfaceClassName = 'bg-background';
